/** The shared library inside the editor: pick files to copy into this project. */

import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { api, type LibraryItem } from "../api";
import { LibraryBrowser } from "../SharedLibrary";
import { addAssets } from "./Library";
import { useEditor } from "./store";

export function SharedLibraryDialog() {
  const project = useEditor((s) => s.project)!;
  const [admin, setAdmin] = useState(false);
  const [added, setAdded] = useState<string[]>([]);
  const close = () => useEditor.getState().set({ panel: null });

  useEffect(() => {
    api.session().then((s) => setAdmin(!!s.user?.admin)).catch(() => {});
  }, []);

  const use = async (items: LibraryItem[]) => {
    const errs = addAssets(await api.fromLibrary(project.id, items.map((i) => i.id)));
    if (errs.length) throw new Error(errs.join("\n"));
    setAdded((a) => [...a, ...items.map((i) => i.name)]);
  };

  return (
    <div className="modal-back" onPointerDown={close}>
      <div className="modal shared-library" onPointerDown={(e) => e.stopPropagation()}>
        <header>
          <h3>Shared library</h3>
          <button className="icon" onClick={close}><X size={18} /></button>
        </header>
        <p className="muted small">
          Files here are shared by everyone. <strong>Use</strong> copies a file into this project's assets (images then get analysed as usual).
          {added.length > 0 && <span className="good"> Added: {added.join(", ")}.</span>}
        </p>
        <LibraryBrowser admin={admin} onUse={use} />
      </div>
    </div>
  );
}
